// Filter & sort popup on the collection page. The <dialog> gives the backdrop,
// Escape-to-close and focus handling. Apply / Clear All re-render the section
// through the Section Rendering API instead of reloading the page.
const collectionFilters = {
  async render(sectionId, search, pushState = true) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section) return;

    section.querySelector('.collection-filters')?.close();
    section.querySelector('#ProductGridContainer')?.classList.add('is-loading');

    const params = new URLSearchParams(search);
    params.set('section_id', sectionId);

    try {
      const response = await fetch(`${location.pathname}?${params}`);
      if (!response.ok) throw new Error(response.status);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      section.innerHTML = html.getElementById(`shopify-section-${sectionId}`).innerHTML;
    } catch (error) {
      // Fall back to a normal page load so the filters still apply
      location.search = search;
      return;
    }

    // Swym binds wishlist buttons once on load; bind the freshly rendered cards
    window._swat?.initializeActionButtons?.(`#shopify-section-${sectionId}`);

    if (pushState) history.pushState({ sectionId }, '', `${location.pathname}${search ? `?${search}` : ''}`);
    window.scrollTo({ top: 0 });
  },
};

document.addEventListener('submit', (event) => {
  const form = event.target.closest('.collection-filters__form');
  if (!form) return;
  event.preventDefault();
  collectionFilters.render(form.dataset.sectionId, new URLSearchParams(new FormData(form)).toString());
});

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-filters-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.filtersOpen);
    if (opener.hasAttribute('data-filters-sort')) dialog?.querySelector('.collection-filters__group--sort')?.setAttribute('open', '');
    dialog?.showModal();
    return;
  }

  if (event.target.closest('[data-filters-close]')) {
    event.target.closest('dialog')?.close();
    return;
  }

  const clearAll = event.target.closest('.collection-filters__clear');
  if (clearAll) {
    event.preventDefault();
    const form = clearAll.closest('.collection-filters__form');
    collectionFilters.render(form.dataset.sectionId, new URL(clearAll.href).search.slice(1));
    return;
  }

  // A click on the backdrop lands on the dialog element itself
  if (event.target.matches('dialog.collection-filters')) event.target.close();
});

// The theme header (main.js) stays shown while the cursor is in the top strip, tracked on mousemove.
// The popup's close button sits in that strip, so after closing the header stopped hiding on wheel scroll
// until the mouse moved. Report the cursor as below the header once the popup closes.
// `close` doesn't bubble, hence the capture listener.
document.addEventListener(
  'close',
  (event) => {
    if (!event.target.matches('dialog.collection-filters')) return;
    window.dispatchEvent(new MouseEvent('mousemove', { clientY: window.innerHeight }));
  },
  true
);

window.addEventListener('popstate', () => {
  const form = document.querySelector('.collection-filters__form');
  if (form) collectionFilters.render(form.dataset.sectionId, location.search.slice(1), false);
});
